export default "__VITE_ASSET__eCQF6fP6__"